import React, { FC } from 'react'

import { IconSocialYoutubeProps } from './IconSocialYoutube.types'
import * as Styled from './styles/IconSocialYoutube.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSocialYoutube: FC<IconSocialYoutubeProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSocialYoutubeProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconSocialYoutubeProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M158.2 46.6a20.6 20.6 0 0 0-17.9-18.1 468.12 468.12 0 0 0-120.6 0A20.5 20.5 0 0 0 1.9 46.6a299.3 299.3 0 0 0 0 66.9 20.5 20.5 0 0 0 17.8 18.1 468.8 468.8 0 0 0 60.4 3.9 467.26 467.26 0 0 0 60.3-3.9 20.5 20.5 0 0 0 17.8-18.1 288.13 288.13 0 0 0 1.9-33.5 286.43 286.43 0 0 0-1.9-33.4zm-53.94 35.52-.06.08a3 3 0 0 1-.9 1l-32.8 23.1a2.89 2.89 0 0 1-4-.7 2.62 2.62 0 0 1-.5-1.7V56a2.88 2.88 0 0 1 2.8-2.9 3.37 3.37 0 0 1 1.7.5l32.8 23.1a3.89 3.89 0 0 1 .96 5.42z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSocialYoutube
